import React from "react";
import { TFunction } from "i18next";
import { Button } from "primereact/button";
import { LeftIdwalGradeSvg, RightIdwalGradeSvg } from "./Svgs";

const getLocaleValue = (i18nKey: string, t: TFunction) => {
    return t(i18nKey);
};

export const Title = (t: TFunction) => (
    <p
        className={
            "vesselsValueOptIn__text text-base p-dialog-title pb-3 font-semibold header-text"
        }
    >
        {getLocaleValue("vesselsValueOptIn.title", t)}
    </p>
);

export const FirstParagraph = (t: TFunction) => (
    <p className={"vesselsValueOptIn__text text-sm"}>
        {getLocaleValue("vesselsValueOptIn.firstContent", t)}
    </p>
);

export const Buttons = (
    t: TFunction,
    agreeCallback: () => void,
    expandFunction: () => void,
    declineCallback: () => void,
    showRestrictButton: boolean
) => (
    <>
        {showRestrictButton ? (
            <Button
                label={getLocaleValue("vesselsValueOptIn.restrictButton", t)}
                onClick={() => {
                    declineCallback();
                }}
                className="mb-3 md:mb-0 md:mr-3 text-sm"
                id={"vesselsValueOptIn__restrictButton"}
            />
        ) : (
            <Button
                label={getLocaleValue("vesselsValueOptIn.learnMore", t)}
                onClick={() => {
                    expandFunction();
                }}
                className="mb-3 md:mb-0 md:mr-3 text-sm"
                id={"vesselValueOptIn__learnMore"}
            />
        )}
        <Button
            label={getLocaleValue("vesselsValueOptIn.agree", t)}
            onClick={() => agreeCallback()}
            className={"vesselValueOptIn__button text-sm"}
            id={"vesselValueOptIn__agreeButton"}
            autoFocus
        />
    </>
);

export const LearnMoreContent = (t: TFunction) => (
    <div className={"grid"} id={"vesselsValueOptIn__learnMoreContainer"}>
        <div className={"col-12 md:col-12 text-center w-full pb-0"}>
            <div id={"vesselsValueOptIn__title"} className={"pt-0 pb-1"} />
        </div>
        <div className={"col-12 md:col-6"}>
            <div className={"vesselsValueOptIn__gradeContainer"}>
                {LeftIdwalGradeSvg}
                <p
                    className={
                        "font-italic vesselsValueOptIn__text pt-1 font-light text-sm"
                    }
                >
                    {getLocaleValue("vesselsValueOptIn.exampleGrade", t)}
                </p>
            </div>
            <p className={"vesselsValueOptIn__text text-sm pt-3"}>
                {getLocaleValue("vesselsValueOptIn.the", t)}
                <strong>
                    {getLocaleValue("vesselsValueOptIn.estimatedGrade", t)}
                </strong>
                {getLocaleValue("vesselsValueOptIn.learnMoreLeft", t)}
            </p>
        </div>
        <div className={"col-12 md:col-6"}>
            <div className={"vesselsValueOptIn__gradeContainer"}>
                {RightIdwalGradeSvg}
                <p
                    className={
                        "font-italic vesselsValueOptIn__text pt-1 font-light text-sm"
                    }
                >
                    {getLocaleValue("vesselsValueOptIn.exampleGrade", t)}
                </p>
            </div>

            <p className={"vesselsValueOptIn__text text-sm pt-3"}>
                {getLocaleValue("vesselsValueOptIn.the", t)}
                <strong>
                    {getLocaleValue("vesselsValueOptIn.verifiedGrade", t)}
                </strong>
                {getLocaleValue("vesselsValueOptIn.learnMoreRight", t)}
            </p>
        </div>
    </div>
);
